import { triggerGAEvent } from '../../../utils/helpers/googleAnalytics';

const transactionsCategory = 'Transactions Tab';

export function triggerTransactionsTabClickEvent(coreId) {
  triggerGAEvent(transactionsCategory, 'Open', coreId);
}
